'use client';

import { FC } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import type { FileMetaDataConfigDto } from '@/api/ApiClient';
import { sortMetadataConfigFields } from '@/lib/fileMetadata/instrumentMetadataConfig';

export interface InstrumentFileMetadataReadonlyPanelProps {
  config: FileMetaDataConfigDto;
  /** Section title inside the grid detail panel. */
  title?: string;
}

/** Read-only file metadata field list for customizing grid expand rows. */
export const InstrumentFileMetadataReadonlyPanel: FC<InstrumentFileMetadataReadonlyPanelProps> = ({
  config,
  title = 'File metadata fields',
}) => {
  const fields = sortMetadataConfigFields(config.fields ?? []);
  if (fields.length === 0) {
    return null;
  }

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      <TableContainer sx={{ overflow: 'visible' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Label</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((field, index) => (
              <TableRow key={field.id ?? `${field.label}-${index}`}>
                <TableCell>{field.label ?? '—'}</TableCell>
                <TableCell>{field.type ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
